import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useMessageThread } from "../../context/MessageThreadContext";
import history from "../../helpers/history";

export const useFetchMessageThread = () => {
  const { messageThread, fetching, fetchMessageThread } = useMessageThread();
  const { group_key } = useParams<{ group_key: string }>();
  const { pathname } = useLocation<{ pathname: string }>();

  const makeActive = (id: string) => {
    const splitLocation = pathname.split("/");

    if (splitLocation[2]) {
      return splitLocation[2] === id ? "bg-secondary" : "";
    }
    return "";
  };

  useEffect(() => {
    if (group_key) {
      fetchMessageThread(group_key);
    } else if (messageThread.length >= 1) {
      history.push(`/messages/${messageThread[0].group_key}`);
    }
  }, [group_key, fetchMessageThread]);

  return { group_key, messageThread, fetching, makeActive };
};
